import * as React from 'react';
import ReactModal from 'react-modal';
import classNames from 'classnames';
import SvgIcon from '../SvgIcon';

import './styles.scss';

ReactModal.setAppElement('body');

export type IMPModalProps = ReactModal.Props;

const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    transform: 'translate(-50%, -50%)',
    padding: 0,
    border: 0,
  },
  overlay: {
    background: 'rgba(69, 81, 84, 0.5)',
  },
};

const MPModal: React.FunctionComponent<IMPModalProps> = ({ className, children, ...props }) => {
  const cn = classNames('MPModal', className);
  return (
    <ReactModal style={customStyles} {...props}>
      <div className={cn}>
        <button className="MPModal-close" onClick={props.onRequestClose as any}>
          <SvgIcon iconName="close" iconWidth={18} iconHeight={18} />
        </button>
        <div className="MPModal-content">{children}</div>
      </div>
    </ReactModal>
  );
};

export default React.memo<IMPModalProps>(MPModal) as any;



// WEBPACK FOOTER //
// ./src/components/MPModal/index.tsx